import { useMemo } from 'react'

import { path as alertPath } from './alert'
import { AtypicalityCheckCalcs } from '@/types/unlock'

const useAtypicalityAlerts = (atypicalityCheckCalcs: Partial<AtypicalityCheckCalcs>) => {
  const alerts = useMemo(() => {
    return atypicalityCheckCalcs
      ? {
          'avm-less-than-threshold': {
            message: `AVM Value < $${atypicalityCheckCalcs?.avm_less_than_exception_threshold?.toLocaleString()}`,
            path: alertPath['valuations'],
          },
          'avm-more-than-threshold': {
            message: `AVM Value > $${atypicalityCheckCalcs?.avm_more_than_exception_threshold?.toLocaleString()}`,
            path: alertPath['valuations'],
          },
          'gross-living-area-minimum-flag': {
            message: `GLA < ${atypicalityCheckCalcs?.gross_living_area_exception_minimum_threshold?.toLocaleString()} sqft`,
            path: alertPath['propertyDetails'],
          },
          'gross-living-area-maximum-flag': {
            message: `GLA > ${atypicalityCheckCalcs?.gross_living_area_exception_maximum_threshold?.toLocaleString()} sqft`,
            path: alertPath['propertyDetails'],
          },
          'number-of-bedrooms-flag': {
            message: `Bedrooms > ${atypicalityCheckCalcs?.number_of_bedrooms_exception_threshold}`,
            path: alertPath['propertyDetails'],
          },
          'lot-acres-flag': {
            message: `Lot Size (in acres) > ${atypicalityCheckCalcs?.lot_acres_exception_threshold}`,
            path: alertPath['propertyDetails'],
          },
          'year-built-flag': {
            message: `Year Built < ${atypicalityCheckCalcs?.year_built_exception_threshold}`,
            path: alertPath['propertyDetails'],
          },
          'yard-debris-coverage-flag': {
            message: `Yard Debris Coverage (in sq_ft) > ${atypicalityCheckCalcs?.yard_debris_coverage_exception_threshold} sqft`,
            path: alertPath['propertyDetails'],
          },
          'property-type-flag': {
            message: 'Property Type Ineligible',
            path: alertPath['propertyDetails'],
          },
          'eligible-state-flag': {
            message: 'Property State Ineligible',
            path: alertPath['propertyDetails'],
          },
          'property-roof-solar-panel-flag': {
            message: 'Roof Solar Panel <> No',
            path: alertPath['propertyDetails'],
          },
          'avm-missing': {
            message: 'AVM Value',
            path: alertPath['valuations'],
          },
          'gla-missing': {
            message: 'GLA',
            path: alertPath['propertyDetails'],
          },
          'number-of-bedrooms-missing': {
            message: 'Bedrooms',
            path: alertPath['propertyDetails'],
          },
          'lot-acres-missing': {
            message: 'Lot Size (in acres)',
            path: alertPath['propertyDetails'],
          },
          'year-built-missing': {
            message: 'Year Built',
            path: alertPath['propertyDetails'],
          },
          'yard-debris-coverage-missing': {
            message: 'Yard Debris Coverage',
            path: alertPath['propertyDetails'],
          },
          'property-type-missing': {
            message: 'Property Type',
            path: alertPath['propertyDetails'],
          },
          'property-roof-solar-panel-missing': {
            message: 'Roof Solar Panel',
            path: alertPath['propertyDetails'],
          },
        }
      : {}
  }, [atypicalityCheckCalcs])

  return alerts
}

export default useAtypicalityAlerts
